export const normalizeSubscriptionsFilters = (filters) => {
  return {
    ...(filters?.user && {user: filters.user}),
    ...(filters?.plan && {plan: filters.plan}),
    ...(filters?.status && {status: filters.status}),
    ...(filters?.dueDateType && {dueDateType: filters.dueDateType}),
    ...(filters?.payment_method && {payment_method: filters.payment_method}),
  }
}